export const LOAD_ACCESS_STATUS = 'LOAD_ACCESS_STATUS'